<template>
  <div>
    <label :for="name" class="block text-xs font-bold text-cal-525252 p-0">{{ label }}:</label>
    <div class="mt-2">
      <input
          :type="type"
          :name="name"
          :id="name"
          :value="value"
          :placeholder="placeholder"
          v-model="model"
          class="block w-full sm:text-sm border border-gray-300 p-2"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'TextInput',
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
}
</script>
